<template>
    <div class="w-full">

        <h4 class="mb-3">{{ $t('AccessTerminals') }}</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addTerminalPrompt = true">
            {{ $t('Add') }}</vs-button>

        <vx-card id="terminalsDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openTerminal" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">{{ $t('TerminalName') }}</vs-th>
                    <vs-th sort-key="status">{{ $t('Status') }}</vs-th>
                    <vs-th sort-key="last_ping_time">{{ $t('LastPingTime') }}</vs-th>
                    <vs-th sort-key="actuation_type">{{ $t('ActuationType') }}</vs-th>
                    <vs-th sort-key="actuation_terminal">{{ $t('ActuationTerminal') }}</vs-th>
                    <vs-th sort-key="actuation_length">{{ $t('ActuationLength') }}</vs-th>
                    <vs-th sort-key="exit_only">{{ $t('UnconditionalExit') }}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].name">
                            {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].status">
                            <vs-chip v-if="data[index].status === 0" color="danger">
                                {{$t('Offline')}}
                            </vs-chip>
                            <vs-chip v-else color="success">
                                {{$t('Online')}}
                            </vs-chip>
                        </vs-td>

                        <vs-td :data="data[index].last_ping_time">
                            {{ moment(data[index].last_ping_time).format('YYYY/MM/DD HH:mm:ss') }}
                        </vs-td>

                        <vs-td :data="data[index].actuation_type">
                            {{ actuationTypes[data[index].actuation_type].name }}
                        </vs-td>

                        <vs-td :data="data[index].actuation_terminal">
                            <p v-if="data[index].actuation_terminal_id === 0">
                                {{$t('ThisTerminal')}}
                            </p>
                            <p v-else>
                                {{data[index].actuation_terminal}}
                            </p>
                        </vs-td>

                        <vs-td :data="data[index].actuation_length">
                            {{ data[index].actuation_length }}
                        </vs-td>

                        <vs-td :data="data[index].exit_only">
                            <vs-chip v-if="data[index].exit_only" color="success">
                                {{$t('Yes')}}
                            </vs-chip>
                            <vs-chip v-else color="danger">
                                {{$t('No')}}
                            </vs-chip>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup :title="$t('AddTerminal')" :active.sync="addTerminalPrompt">
            <div id="addTerminalDiv" class="vs-con-loading__container" >
                <vs-checkbox class="mt-3" v-model="addObject['exit_only']">{{ $t('UnconditionalExit') }}</vs-checkbox>

                <p class="mt-6">{{ $t('TerminalName') }}</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">{{ $t('ActuationType') }}</p>
                <vs-select autocomplete class="w-full" v-model="addObject['actuation_type']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in actuationTypes" />
                </vs-select>
                <p class="mt-6">{{ $t('ActuationTerminal') }}</p>
                <vs-select autocomplete class="w-full" v-model="addObject['actuation_terminal_id']">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id: 0, name: $t('ThisTerminal')}].concat(terminals)" />
                </vs-select>
                <p class="mt-6">{{ $t('ActuationLength') }}</p>
                <vs-input v-model="addObject['actuation_length']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addTerminal">{{ $t('Add') }}</vs-button>
            </div>
        </vs-popup>
    </div>
</template>
<script>
    export default {

        data() {
            return {

                itemsPerPage: 20,
                isMounted: false,

                terminals: [],

                addTerminalPrompt: false,

                addObject: {
                    actuation_type: 0,
                    actuation_terminal_id: 0
                },

                actuationTypes: [
                    {
                        id: 0,
                        name: this.$t('Relay')
                    },
                    {
                        id: 1,
                        name: this.$t('GPIO')
                    }
                ]

            }
        },
        methods: {
            openTerminal(tr) {
                this.$router.push(`/terminal/${tr.id}`)
            },
            loadData() {
                this.$vs.loading({
                    container: '#terminalsDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/access_terminal/')
                loadPromise.then(function(response) {
                    thisIns.terminals = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#terminalsDiv > .con-vs-loading')
                })
            },
            addTerminal() {
                this.$vs.loading({
                    container: '#addTerminalDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/access_terminal/', {
                    name: this.addObject.name,
                    actuation_type: Number(this.addObject.actuation_type),
                    actuation_terminal_id: Number(this.addObject.actuation_terminal_id),
                    actuation_length: Number(this.addObject.actuation_length),
                    exit_only: this.addObject.exit_only
                })

                addPromise.then(function() {
                    thisIns.addTerminalPrompt = false
                    thisIns.$printSuccess(thisIns.$t('TerminalAdded'))
                    thisIns.$nextTick(() => {
                        thisIns.loadData()
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addTerminalDiv > .con-vs-loading')
                })
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.terminals
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }
    }
</script>
